import {BaseConnection} from './BaseConnection';

export class ApiConnection extends BaseConnection {}

